'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js'], function (Vue) {
	Vue.component('word-defined-edit', {
		props: ['word', 'removeWord', 'initData'],
		data: function () {
			return {

			};
		},
		computed: {
			letters: function () {
				var letters = this.word.word.split('');
				
				var lettersObject = [];
				for (var i = 0; i < letters.length; i++) {
					lettersObject.push({
						letter: letters[i],
						isSelected: this.word.lettersToHide.indexOf(i) >= 0,
						disabled: letters[i] === ' '
					});
				}
				
				return lettersObject;
			}
		},
		methods: {
			selectLetter: function (index) {
				var pos = this.word.lettersToHide.indexOf(index);
				
				if (pos >= 0) {
					this.word.lettersToHide.splice(pos, 1);
				} else {
					this.word.lettersToHide.push(index);
				}
			},
		},
		template:
			'<div class="">' +
				'<small class="d-block">{{initData.translations.selectLettersToHideHelp}}</small>' +
				'<button class="btn" type="button" v-for="(letter, index) in letters" :disabled="letter.disabled" v-on:click="selectLetter(index)" :class="{ \'btn-primary\': letter.isSelected }">{{letter.letter}}</button>' +
			'</div>',
	});
});
